import isValidMinMaxBet from "@casino/legacy/shared/utils/game/isValidMinMaxBet";
import isValidVolatility from "@casino/legacy/shared/utils/game/isValidVolatility";
import type { GameFragment } from "@workspace/casino_core/fragments/GameFragment";
import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";

// List cards carry only the shared fields; the play page the full game.
type GameDetailsGame = GameFragment & Partial<SingleGameFragment>;

const hasAnyData = (
  game: GameDetailsGame,
  currencyCode: CashierCurrency | BtcUnit,
) => {
  const { minBet, maxBet, rtp, volatility, payLines, hitRatio } = game;
  return (
    ((minBet || maxBet) && isValidMinMaxBet(currencyCode)) ||
    rtp ||
    isValidVolatility(volatility) ||
    payLines ||
    hitRatio
  );
};

export default hasAnyData;
